import { Image, Text, View } from '@react-pdf/renderer';
import { getPluralization } from '@utils/getPluralization';
import _ from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Driver, Vehicle, VehicleType } from '../../../types';
import busImage from '../assets/bus.png';
import driverImage from '../assets/driver.png';
import truckImage from '../assets/truck.png';
import vanImage from '../assets/van.png';

const ICON_STYLES = { width: 10, height: 10, marginLeft: 5, marginRight: 5 };

const getPrefixedKey = (type: string) => `VehicleSummary-VehicleIcon-${type}`;

const driverIcon = <Image src={driverImage} style={ICON_STYLES} />;
const truckIcon = <Image src={truckImage} style={ICON_STYLES} key={getPrefixedKey(VehicleType.TRUCK)} />;
const busIcon = <Image src={busImage} style={ICON_STYLES} key={getPrefixedKey(VehicleType.BUS)} />;
const vanIcon = <Image src={vanImage} style={ICON_STYLES} key={getPrefixedKey(VehicleType.VAN)} />;

export default function VehicleSummary({ vehicles, drivers }: { vehicles: Vehicle[]; drivers: Driver[] }) {
    const vehicleTypes = _.map(vehicles, 'type');
    const vehicleIcons = [
        vehicleTypes.includes(VehicleType.TRUCK) && truckIcon,
        vehicleTypes.includes(VehicleType.BUS) && busIcon,
        vehicleTypes.includes(VehicleType.VAN) && vanIcon,
    ].filter(Boolean);

    const pluralizedDriver = getPluralization('driver', 'drivers', drivers.length);
    const pluralizedVehicle = getPluralization('vehicle', 'vehicles', vehicles.length);

    return (
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <FormattedMessage id="print.with" />
            <Text> </Text>
            {vehicles.length ? (
                <React.Fragment>
                    {vehicleIcons}
                    <FormattedMessage
                        id="vehicleCount"
                        values={{
                            vehicleCount: vehicles.length,
                            pluralizedVehicle,
                        }}
                    />
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <FormattedMessage id="fleetOf" />
                    {vehicleIcons}
                    <Text>
                        <FormattedMessage
                            id="vehicleCount"
                            values={{
                                vehicleCount: vehicles.length,
                                pluralizedVehicle,
                            }}
                        />
                    </Text>
                </React.Fragment>
            )}
            <Text> </Text>
            <FormattedMessage id="print.and" />
            <Text> </Text>
            {drivers.length ? (
                <React.Fragment>
                    {driverIcon}
                    <Text>
                        <FormattedMessage
                            id="driverCount"
                            values={{
                                driverCount: drivers.length,
                                pluralizedDriver,
                            }}
                        />
                    </Text>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <FormattedMessage id="teamOf" />
                    {driverIcon}
                    <Text>
                        <FormattedMessage
                            id="driverCount"
                            values={{
                                driverCount: drivers.length,
                                pluralizedDriver,
                            }}
                        />
                    </Text>
                </React.Fragment>
            )}
        </View>
    );
}
